// ============================================================
// tx.ioTemplate.js — 导入 / 导出模板逻辑
// 依赖 ttx.io 的文件能力（saveUrl / saveBlob / openFile / readFileText）
// 模板来源：接口 /api/template/io-templates（元数据驱动，可导入/可导出过滤）
// ============================================================

window.ttx = window.ttx || {};
window.ttx.ioTemplate = {};

(function () {
    var ttx = window.ttx;

    function getVm(vm) {
        return vm || (ttx.debug && ttx.debug.getCurrentVM && ttx.debug.getCurrentVM());
    }

    function getBillno(vm) {
        var params = (vm.getParams && vm.getParams()) || {};
        var template = vm._get_data && vm._get_data('template');
        return params.billno || params.billNo
            || (vm._get_data && vm._get_data('serviceCode'))
            || (template && template.serviceCode) || '';
    }

    function toast(type, msg) {
        if (ttx.toast && typeof ttx.toast[type] === 'function') ttx.toast[type](msg);
        else if (ttx.console) ttx.console.warn('[ioTemplate] ' + msg);
    }

    /** 页面模板里配置的导入/导出模板（可选，配置了就优先用） */
    function getConfiguredTemplate(vm, type) {
        var template = vm._get_data && vm._get_data('template');
        var view = (template && template.view) || {};
        var list = view[type + 'Templates'];
        if (Array.isArray(list) && list.length) return list[0];
        var single = view[type + 'Template'];
        // 只要配置了对象就返回：即使没配列，规则链、跳过表头行数等配置也要生效
        return single && typeof single === 'object' ? single : null;
    }

    /** 当前列表查询条件（筛选/查询区），导出任务按它取全量数据 */
    function getListQuery(vm) {
        var query = {};
        try {
            var searchModel = vm.getCache && vm.getCache('searchModel');
            var values = searchModel && searchModel.getQueryValues ? searchModel.getQueryValues() : {};
            query = { params: { mode: 'list', query: values || {} } };
            var filter = vm.getCache && vm.getCache('filter');
            if (filter) query.filter = filter;
        } catch (e) { }
        return query;
    }

    function sleep(ms) {
        return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    /** 创建异步任务 */
    function createIoTask(url, data) {
        return new Promise(function (resolve, reject) {
            if (!ttx.ajax || !ttx.ajax.xhrUtil) { reject(new Error('当前环境不支持请求')); return; }
            ttx.ajax.xhrUtil({
                url: url,
                method: 'post',
                data: data,
                showErrorToast: false,
                success: function (res) {
                    if (res && res.code === 200 && res.data && res.data.id) resolve(res.data);
                    else reject(new Error((res && res.message) || '创建任务失败'));
                },
                error: function (err) { reject(new Error((err && err.message) || '创建任务失败')); },
            });
        });
    }

    /** 轮询任务进度，直到完成/失败/取消 */
    function pollIoTask(taskId, onProgress) {
        var startedAt = Date.now();
        function tick() {
            return new Promise(function (resolve, reject) {
                if (!ttx.ajax || !ttx.ajax.xhrUtil) { reject(new Error('当前环境不支持请求')); return; }
                ttx.ajax.xhrUtil({
                    url: '/api/template/io-task',
                    method: 'get',
                    data: { id: taskId },
                    showErrorToast: false,
                    success: function (res) {
                        if (!res || res.code !== 200 || !res.data) {
                            reject(new Error((res && res.message) || '任务查询失败'));
                            return;
                        }
                        var task = res.data;
                        if (typeof onProgress === 'function') onProgress(task);
                        if (task.status === 'success' || task.status === 'failed' || task.status === 'canceled') {
                            resolve(task);
                            return;
                        }
                        if (Date.now() - startedAt > 30 * 60 * 1000) {
                            reject(new Error('任务处理超时，请稍后重试'));
                            return;
                        }
                        sleep(800).then(tick).then(resolve, reject);
                    },
                    error: function (err) { reject(new Error((err && err.message) || '任务查询失败')); },
                });
            });
        }
        return tick();
    }

    /** 优先用页面 React 弹框（表格选择模板）；未注册返回 false */
    function openVmPicker(vm, type, onPick) {
        var opener = vm.getCache && vm.getCache('openIoModal');
        if (typeof opener !== 'function') return false;
        opener(type, onPick);
        return true;
    }

    /** 兜底：简易 DOM 模板选择框（页面未注册 React 弹框时使用） */
    function pickTemplate(title, list, onOk) {
        var mask = document.createElement('div');
        mask.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:100000;display:flex;align-items:center;justify-content:center;';
        var box = document.createElement('div');
        box.style.cssText = 'width:420px;max-height:60vh;overflow:auto;background:#fff;border-radius:6px;padding:16px;box-shadow:0 8px 24px rgba(0,0,0,.2);font-size:13px;color:#1d2129;';
        box.innerHTML = '<div style="font-size:14px;font-weight:600;margin-bottom:12px;">' + title + '</div>';
        var selected = 0;
        var listWrap = document.createElement('div');
        listWrap.style.cssText = 'max-height:40vh;overflow:auto;border:1px solid #e5e6eb;border-radius:4px;';
        list.forEach(function (tpl, index) {
            var row = document.createElement('label');
            row.style.cssText = 'display:flex;align-items:center;gap:8px;padding:8px 10px;border-bottom:1px solid #f2f3f5;cursor:pointer;';
            var radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'ttx_io_tpl';
            radio.checked = index === 0;
            radio.onchange = function () { selected = index; };
            var text = document.createElement('span');
            text.textContent = tpl.name || ('模板' + (index + 1));
            row.appendChild(radio);
            row.appendChild(text);
            listWrap.appendChild(row);
        });
        box.appendChild(listWrap);
        var footer = document.createElement('div');
        footer.style.cssText = 'display:flex;justify-content:flex-end;gap:8px;margin-top:14px;';
        var cancel = document.createElement('button');
        cancel.textContent = '取消';
        cancel.style.cssText = 'padding:5px 14px;border:1px solid #e5e6eb;background:#fff;border-radius:4px;cursor:pointer;';
        var ok = document.createElement('button');
        ok.textContent = '确定';
        ok.style.cssText = 'padding:5px 14px;border:none;background:#165dff;color:#fff;border-radius:4px;cursor:pointer;';
        cancel.onclick = function () { document.body.removeChild(mask); };
        ok.onclick = function () {
            document.body.removeChild(mask);
            var tpl = list[selected];
            if (tpl) onOk(tpl);
        };
        footer.appendChild(cancel);
        footer.appendChild(ok);
        box.appendChild(footer);
        mask.appendChild(box);
        document.body.appendChild(mask);
    }

    /** 元数据生成模板列表（接口查询） */
    function loadTemplateList(vm, type) {
        var configured = getConfiguredTemplate(vm, type);
        if (configured) return Promise.resolve([configured]);
        var serviceCode = getBillno(vm);
        if (!serviceCode) return Promise.resolve([]);
        return new Promise(function (resolve) {
            if (!ttx.ajax || !ttx.ajax.xhrUtil) { resolve([]); return; }
            ttx.ajax.xhrUtil({
                url: '/api/template/io-templates',
                method: 'get',
                data: { serviceCode: serviceCode, type: type },
                showErrorToast: false,
                success: function (res) {
                    var list = res && res.code === 200 ? (res.data || []) : [];
                    resolve(Array.isArray(list) ? list : []);
                },
                error: function () { resolve([]); },
            });
        });
    }

    /** 下载导入模板（服务端生成 xlsx） */
    function downloadImportTemplate(vm, template) {
        var serviceCode = getBillno(vm);
        // 列配置优先级：页面「导入模板」配置 > 所选模板自带列，保证表头与配置/导入解析一致
        var pageColumns = ((getConfiguredTemplate(vm, 'import') || {}).columns || []);
        var configured = pageColumns.length
            ? pageColumns
            : ((template && Array.isArray(template.columns)) ? template.columns : []);
        var url = '/api/template/io-template-file?serviceCode=' + encodeURIComponent(serviceCode)
            + '&entityId=' + encodeURIComponent((template && template.id) || '');
        if (configured.length) {
            var columnsJson = configured.map(function (column) {
                return { field: column.field, label: column.label, required: !!column.required };
            });
            url += '&columns=' + encodeURIComponent(JSON.stringify(columnsJson));
        }
        ttx.io.saveUrl(url, ((template && template.name) || '导入模板') + '.xlsx')
            .then(function () { toast('success', '导入模板已下载'); })
            .catch(function (e) { toast('error', (e && e.message) || '下载模板失败'); });
    }

    /** 按模板导出数据（服务端异步任务 + 多页签工作簿） */
    function exportData(vm, template) {
        var serviceCode = getBillno(vm);
        var pageConfig = getConfiguredTemplate(vm, 'export');
        var columns = (pageConfig && pageConfig.columns && pageConfig.columns.length)
            ? pageConfig.columns
            : ((template && Array.isArray(template.columns)) ? template.columns : []);
        var fileName = ((template && template.name) || '导出数据') + '.xlsx';
        var exportFileName = (pageConfig && pageConfig.fileName) || '';
        var downloadName = exportFileName || fileName;
        if (!/\.xlsx$/i.test(downloadName)) downloadName += '.xlsx';
        var load = ttx.loading && ttx.loading.showInCurrentTab && ttx.loading.showInCurrentTab();
        createIoTask('/api/template/io-export-task', {
            serviceCode: serviceCode,
            entityId: (template && template.id) || '',
            columns: columns,
            query: getListQuery(vm),
            fileName: exportFileName,
        })
            .then(function (task) {
                if (ttx.console) ttx.console.log('[ioTemplate] 导出任务已创建：' + task.id);
                return pollIoTask(task.id, function (progress) {
                    if (ttx.console) ttx.console.log('[ioTemplate] 导出进度 ' + (progress.progress || 0) + '%');
                });
            })
            .then(function (task) {
                if (task.status !== 'success') throw new Error(task.error || '导出失败');
                return ttx.io.saveUrl(
                    '/api/template/io-task/download?id=' + encodeURIComponent(task.id),
                    downloadName,
                );
            })
            .then(function () { toast('success', '导出成功'); })
            .catch(function (e) { toast('error', (e && e.message) || '导出失败'); })
            .then(function () { if (load && load.hide) load.hide(); });
    }

    /**
     * 上传导入文件并创建异步任务：
     * 解析、导入前规则链、逐行写库都在服务端任务内执行，这里只拿 taskId 轮询进度。
     * 这样大文件解析不会再卡在单次同步请求上（原实现有 120s 超时与 10MB 请求体限制）。
     */
    function createImportTaskFromFile(file, billno, config, extra) {
        var fd = new FormData();
        fd.append('file', file);
        fd.append('serviceCode', billno);
        fd.append('entityId', (config && config.id) || '');
        fd.append('columns', JSON.stringify((config && config.columns) || []));
        fd.append('skipRows', String((config && Number(config.skipRows)) || 0));
        fd.append('extra', JSON.stringify(extra || {}));
        fd.append('matchField', (config && config.matchField) || '');
        fd.append('updateExisting', (config && config.updateExisting) ? '1' : '0');
        fd.append('beforeRuleChainCode', (config && config.beforeRuleChainCode) || '');
        return new Promise(function (resolve, reject) {
            if (!ttx.ajax || !ttx.ajax.xhrUtil) { reject(new Error('当前环境不支持文件上传')); return; }
            ttx.ajax.xhrUtil({
                url: '/api/template/io-import-task',
                method: 'post',
                data: fd,
                // FormData 的 Content-Type 由浏览器自动带 boundary，不能手写
                headers: { 'Content-Type': null },
                timeout: 120000,
                showErrorToast: false,
                success: function (res) {
                    if (res && res.code === 200 && res.data && res.data.id) resolve(res.data);
                    else reject(new Error((res && res.message) || '创建导入任务失败'));
                },
                error: function (err) { reject(new Error((err && err.message) || '创建导入任务失败')); },
            });
        });
    }

    /**
     * 导入前/后规则链的候选挂载 ID：
     * 1. 模板里选择了规则链 → 直接用该链的挂载 ID（任意规则链都可绑定）；
     * 2. 历史上填的是「单据编码前缀」→ 先按原值找，再补 __import_{phase} 后缀兜底；
     * 3. 未配置 → 默认 {单据编码}__import_{phase}。
     */
    function getImportChainBizIds(billno, config, phase) {
        var key = phase === 'before' ? 'beforeRuleChainCode' : 'ruleChainCode';
        var custom = String((config && config[key]) || '').trim();
        if (!custom) return [billno + '__import_' + phase];
        if (/__import_(before|after)$/.test(custom)) return [custom];
        return [custom, custom + '__import_' + phase];
    }

    /** 链配置归一化：不存在 / 禁用 / 无规则项 → 视为未配置 */
    function normalizeImportChain(chain) {
        if (!chain || chain.status === 0 || !Array.isArray(chain.items) || !chain.items.length) return null;
        return {
            chain: chain,
            config: {
                enabled: true,
                stopOnError: false,
                items: chain.items.map(function (item) {
                    return {
                        id: item.id,
                        ruleCode: item.ruleCode,
                        ruleName: item.ruleName,
                        ruleType: item.ruleType,
                        scriptId: item.scriptId,
                        scriptCode: item.scriptCode,
                        sortOrder: item.sortOrder,
                        status: item.status,
                        remark: item.remark,
                    };
                }),
            },
        };
    }

    /** 按挂载 ID 查询；未命中再按「规则链 ID」查询（兼容未设置挂载 ID 的链） */
    function loadImportChainByBizId(chainKey) {
        function query(url, data) {
            return new Promise(function (resolve) {
                if (!ttx.ajax || !ttx.ajax.xhrUtil) { resolve(null); return; }
                ttx.ajax.xhrUtil({
                    url: url,
                    method: 'get',
                    data: data,
                    showErrorToast: false,
                    success: function (res) {
                        resolve(normalizeImportChain(res && res.code === 200 ? res.data : null));
                    },
                    error: function () { resolve(null); },
                });
            });
        }
        return query('/api/rule-chain/by-biz', { bizObjectId: chainKey }).then(function (loaded) {
            return loaded || query('/api/rule-chain/detail', { id: chainKey });
        });
    }

    /** 依次尝试候选挂载 ID，取第一个命中的规则链；优先按「单据+触发事件」查新模型链 */
    function loadImportChain(chainBizIds, billno, phase) {
        function tryNewModel() {
            if (!billno || !phase || !ttx.ajax || !ttx.ajax.xhrUtil) return Promise.resolve(null);
            return new Promise(function (resolve) {
                ttx.ajax.xhrUtil({
                    url: '/api/rule-chain/by-billno-event',
                    method: 'get',
                    data: { billno: billno, event: 'import_' + phase },
                    showErrorToast: false,
                    success: function (res) {
                        resolve(normalizeImportChain(res && res.code === 200 ? res.data : null));
                    },
                    error: function () { resolve(null); },
                });
            });
        }
        return tryNewModel().then(function (loaded) {
            if (loaded) return loaded;
            var list = Array.isArray(chainBizIds) ? chainBizIds : [chainBizIds];
            var index = 0;
            function next() {
                if (index >= list.length) return Promise.resolve(null);
                var id = list[index++];
                return loadImportChainByBizId(id).then(function (loaded) { return loaded || next(); });
            }
            return next();
        });
    }

    /**
     * 导入完成后执行规则链（<单据编码>__import_after）。
     * 链不存在时静默跳过；执行失败仅告警，不影响导入结果。
     * @param {string} billno  单据编码
     * @param {object} config  导入模板配置（可含 ruleChainCode 覆盖默认单据编码）
     * @param {object} result  导入结果 { total, success, failed, failures }
     */
    function runImportAfterChain(billno, config, result) {
        var chainBizIds = getImportChainBizIds(billno, config, 'after');
        return loadImportChain(chainBizIds, billno, 'after').then(function (loaded) {
            if (!loaded) {
                var configuredAfter = String((config && config.ruleChainCode) || '').trim();
                if (configuredAfter && ttx.console) {
                    ttx.console.warn('[ioTemplate] 未找到导入后规则链：' + chainBizIds.join(' / '));
                    toast('warning', '未找到导入后规则链：' + configuredAfter);
                }
                return null;
            }
            if (ttx.console) ttx.console.log('[ioTemplate] 执行导入后规则链：' + loaded.chain.chainCode + '（' + billno + '）');
            return new Promise(function (resolve) {
                ttx.ajax.xhrUtil({
                    url: '/api/rule-chain/execute',
                    method: 'post',
                    data: {
                        ruleChain: loaded.config,
                        context: {
                            billno: billno,
                            operation: 'import_after',
                            data: {
                                total: result.total,
                                success: result.success,
                                failed: result.failed,
                                skipped: result.skipped || 0,
                                failures: result.failures,
                                matchField: (config && config.matchField) || '',
                                updateExisting: !!(config && config.updateExisting),
                            },
                            chainId: loaded.chain.id,
                            chainCode: loaded.chain.chainCode,
                            chainName: loaded.chain.chainName,
                            bizObjectId: loaded.chain.bizObjectId,
                        },
                    },
                    showErrorToast: false,
                    success: function (execRes) {
                        var exec = execRes && execRes.data;
                        if (exec && exec.success === false) {
                            var errs = (exec.errors || []).join('; ');
                            toast('warning', '导入后规则链执行失败（不影响导入结果）' + (errs ? '：' + errs : ''));
                        }
                        resolve(exec || null);
                    },
                    error: function () {
                        toast('warning', '导入后规则链执行失败（不影响导入结果）');
                        resolve(null);
                    },
                });
            });
        });
    }

    /** 导入：打开上传弹框 → 确定 → 执行导入 */
    ttx.ioTemplate.import = function (vm) {
        vm = getVm(vm);
        if (!vm) { toast('warning', '导入失败：未找到当前页面'); return; }
        var opener = vm.getCache && vm.getCache('openImportFileModal');
        if (typeof opener === 'function') {
            opener(function (file, template, onProgress, extra) {
                return file ? ttx.ioTemplate.importFile(vm, file, template, onProgress, extra) : null;
            });
            return;
        }
        ttx.io.openFile('.xlsx,.csv', function (file) {
            ttx.ioTemplate.importFile(vm, file);
        });
    };

    /** 下载导入模板：选择模板 → 下载 xlsx */
    ttx.ioTemplate.importTemplate = function (vm) {
        vm = getVm(vm);
        if (!vm) { toast('warning', '未找到当前页面'); return; }
        if (openVmPicker(vm, 'import', function (tpl) { downloadImportTemplate(vm, tpl); })) return;
        loadTemplateList(vm, 'import').then(function (list) {
            if (!list.length) { toast('warning', '未获取到模板'); return; }
            pickTemplate('选择导入模板', list, function (tpl) { downloadImportTemplate(vm, tpl); });
        });
    };

    /** 导出：选择模板 → 导出 xlsx */
    ttx.ioTemplate.export = function (vm) {
        vm = getVm(vm);
        if (!vm) { toast('warning', '导出失败：未找到当前页面'); return; }
        if (openVmPicker(vm, 'export', function (tpl) { exportData(vm, tpl); })) return;
        loadTemplateList(vm, 'export').then(function (list) {
            if (!list.length) { toast('warning', '未获取到模板'); return; }
            pickTemplate('选择导出模板', list, function (tpl) { exportData(vm, tpl); });
        });
    };

    /**
     * 按文件执行导入（供上传弹框 / 脚本调用），返回 { total, success, failed, skipped, failures }
     * 上传后由服务端异步任务完成解析、导入前规则链与写库，这里轮询进度并取回最终结果。
     * @param extra 导入弹框里选择的固定条件（如数据池客户类型），由服务端并入每一行待写入数据
     */
    ttx.ioTemplate.importFile = function (vm, file, template, onProgress, extra) {
        vm = getVm(vm);
        if (!vm || !file) return Promise.resolve(null);
        var billno = getBillno(vm);
        if (!billno) { toast('warning', '导入失败：未识别当前单据'); return Promise.resolve(null); }
        var load = ttx.loading && ttx.loading.showInCurrentTab && ttx.loading.showInCurrentTab();

        // 优先使用上传弹框里选中的模板（实体 + 列配置），其次页面配置，最后取第一个可用模板。
        // 弹框传入的是实体模板（不含规则链/跳过行等页面级配置），这里与页面配置合并，
        // 保证规则链、跳过表头行数等页面配置不丢失。
        var pageConfig = getConfiguredTemplate(vm, 'import');
        var configured = template
            ? Object.assign({}, pageConfig || {}, template)
            : pageConfig;
        var ready = configured
            ? Promise.resolve(configured)
            : loadTemplateList(vm, 'import').then(function (list) { return (list && list[0]) || null; });
        // 诊断日志：导入配置来源与规则链取值（排查「配了没反应」）
        if (ttx.console) {
            ttx.console.log('[ioTemplate] 导入开始', {
                billno: billno,
                fromPageConfig: !!pageConfig,
                beforeRuleChainCode: (pageConfig && pageConfig.beforeRuleChainCode) || '',
                ruleChainCode: (pageConfig && pageConfig.ruleChainCode) || '',
                columns: ((pageConfig && pageConfig.columns) || []).length,
            });
        }
        var result = { total: 0, success: 0, failed: 0, skipped: 0, failures: [] };
        // 记录实际使用的模板配置，导入完成后供规则链（import_after）读取
        var importConfig = null;

        return ready
            .then(function (config) {
                importConfig = config;
                // 上传即建任务：解析 / 导入前规则链 / 写库都在服务端任务内执行，这里只轮询进度
                return createImportTaskFromFile(file, billno, config, extra).then(function (task) {
                    return pollIoTask(task.id, function (progress) {
                        if (ttx.console) {
                            ttx.console.log('[ioTemplate] 导入进度 ' + (progress.phase || '') + ' ' + (progress.progress || 0) + '%');
                        }
                        if (typeof onProgress === 'function') onProgress(progress);
                    });
                });
            })
            .then(function (task) {
                result.total = Number(task.total) || 0;
                result.success = Number(task.success) || 0;
                result.failed = Number(task.failed) || 0;
                result.skipped = Number(task.skipped) || 0;
                (task.failures || []).forEach(function (msg) { result.failures.push(msg); });
                if (task.status === 'canceled') {
                    result.failures.push('导入任务已取消');
                } else if (task.status === 'failed' && task.error && !result.failures.length) {
                    result.failures.push(task.error);
                }
            })
            .then(function () {
                if (result.success || result.skipped) {
                    var parts = [];
                    if (result.success) parts.push('成功 ' + result.success + ' 条');
                    if (result.skipped) parts.push('并入有效联系人 ' + result.skipped + ' 条');
                    if (result.failed) parts.push('失败 ' + result.failed + ' 条');
                    toast('success', '导入完成：' + parts.join('，'));
                } else if (!result.total) {
                    toast('warning', '文件没有可导入的数据');
                } else {
                    toast('error', '导入失败：' + (result.failures[0] || '没有成功的数据'));
                }
                if (result.failures.length && ttx.console) {
                    ttx.console.warn('[ioTemplate] 导入失败明细：\n' + result.failures.join('\n'));
                }
                if ((result.success || result.skipped) && vm.execute) vm.execute('refresh');
                // 有成功数据时执行导入后规则链（<单据编码>__import_after），失败不影响导入结果
                if (result.success) {
                    return runImportAfterChain(billno, importConfig, result).then(function () { return result; });
                }
                return result;
            })
            .catch(function (err) {
                var message = (err && err.message) || '导入失败';
                toast('error', message);
                result.failures.push(message);
                return result;
            })
            .then(function (res) {
                if (load && load.hide) load.hide();
                return res;
            });
    };

})();
